// extracted by mini-css-extract-plugin
export default {"League":"style_League__Gy2p7","LeagueTdTh":"style_LeagueTdTh__IYY3t"};